/*!

=========================================================
* Light Bootstrap Dashboard PRO React - v2.0.0
=========================================================

* Product Page: https://www.creative-tim.com/product/light-bootstrap-dashboard-pro-react
* Copyright 2020 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";

import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap/dist/css/bootstrap.min.css";
import "assets/scss/light-bootstrap-dashboard-pro-react.scss?v=2.0.0";
import "assets/css/demo.css";

import AuthLayout from "layouts/Auth.js";
import AdminLayout from "layouts/Admin.js";
import KoorLayout from "layouts/Koor.js";
import KoorProduktifLayout from "layouts/KoorProduktif";
import AuthKoorLayout from "layouts/AuthKoor.js";
import AuthKoorProduktifLayout from "layouts/AuthKoorProduktif";
import ProtectedRoute from "ProtectedRoute";
import PDFKiki from "layouts/Download";


import { Provider } from "react-redux";
import { store } from "./stores/index";
import CryptoJS from "crypto-js";
const Data = localStorage.getItem("Data");
const secretKey = "your-secret-key";
let role = null;
if (Data) {
  try {
    const bytes = CryptoJS.AES.decrypt(Data, secretKey);
    const decryptedText = bytes.toString(CryptoJS.enc.Utf8);

    if (decryptedText) {
      role = JSON.parse(decryptedText);

      // Gunakan role disini
    } else {
      console.warn("Decryption failed. Possibly wrong key or corrupted data.");
    }
  } catch (err) {
    console.error("Error decrypting or parsing JSON:", err);
  }
} else {
  console.warn("No encrypted data found in localStorage under 'Data'");
}

// const rolee = localStorage.getItem("Role");
// const kategori = localStorage.getItem("Kategori");

ReactDOM.render(
  <BrowserRouter>
    <Provider store={store}>
      <Switch>
        <Route path="/download" render={(props) => <PDFKiki {...props} />} />
        <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
        <Route
          path="/authKoor"
          render={(props) => <AuthKoorLayout {...props} />}
        />
        <Route
          path="/authKoorProduktif"
          render={(props) => <AuthKoorProduktifLayout {...props} />}
        />

        <ProtectedRoute
          path="/admin"
          render={(props) => <AdminLayout {...props} />}
        />
        <ProtectedRoute
          path="/koor"
          render={(props) => <KoorLayout {...props} />}
        />
        <ProtectedRoute
          path="/koorproduktif"
          render={(props) => <KoorProduktifLayout {...props} />}
        />

        {role &&
        role.Role === "BPD" &&
        role &&
        role.Kategori === "Konsumtif" ? (
          <Redirect from="/" to="/koor/pengajuanKoordinator" />
        ) : role &&
          role.Role === "BPD" &&
          role &&
          role.Kategori === "Produktif" &&
          role &&
          role.Otp === true ? (
          <Redirect
            from="/"
            to="/koorproduktif/pengajuanKoordinatorProduktif"
          />
        ) : (
          <Redirect from="/" to="/admin/dashboard" />
        )}
      </Switch>
    </Provider>
  </BrowserRouter>,

  document.getElementById("root")
);
